module.exports = __webpack_public_path__ + "static/inp-logo-c3e09198eb408796019100f2ecd82bb9.png";